<template>
  <v-dialog persistent width="490" :value="true">
    <div class="employeeWorkSchedulePopup">
      <div class="employeeWorkSchedulePopupHead">
        Employee Name
        <button type="button" @click="onClose">
          <svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
        </button>
      </div>
      <v-text-field
        class="dispatcherList_input"
        label="Select name"
        @input="onInput"
        hide-details
      ></v-text-field>
      <transition-group class="dispatcherList" name="flip-list" tag="div">
        <div
          :key="value"
          v-for="{ value, id, disabled } in employeeList"
          class="dispatcherList_item"
        >
          <v-checkbox
            :input-value="onChecked(id)"
            :label="value"
            :disabled="disabled"
            @change="onCheckbox({ id, value })"
            hide-details
          ></v-checkbox>
        </div>
      </transition-group>
      <button-groups
        margin="20px 0 0"
        @updateBtnClose="onClose"
        @updateSave="onSave"
      ></button-groups>
    </div>
    <preload v-if="isPreloader"></preload>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
import ButtonGroups from "@/shared/ButtonGroups/ButtonGroups";
import Preload from "@/shared/Preload/Preload";
import getClonedObject from "@/helper/getClonedObject";
import debounce from "lodash.debounce";

export default {
	name: "EmployeeWorkSchedulePopup",
	components: { Preload, ButtonGroups },
	props: { editData: Object, tab: Number },
	data: () => ({
		checked: true,
		isPreloader: false,
		employeeSelected: [],
		check: false,
		defaultDispatcherList: [],
		employeeList: null,
	}),
	methods: {
		...mapActions([ 'getScheduleEmployee', 'onScheduleEmployeeSave', 'setAlert' ]),
		onClose() {
			this.$emit("updateClose");
		},
		async onSave() {
			this.isPreloader = true;
			await this.onScheduleEmployeeSave({ tab: this.tab, employeeSelected: this.employeeSelected, ...this.editData });
			this.onClose();
			this.isPreloader = false;
		},
		onInput: debounce(function(value) {
			const cloneList = getClonedObject(this.defaultDispatcherList);
			if (!value) {
				this.employeeList = cloneList;
			} else {
				cloneList.forEach((item) => {
					const lowerCaseValue = item.value.toLowerCase();
					item.disabled = !lowerCaseValue.includes(value.toLowerCase());
				});

				this.employeeList = cloneList.sort((a, b) => a.disabled - b.disabled);
			}
		}, 500),
		onChecked(id) {
			return this.employeeSelected.some(item => item.id === id);
		},
		onCheckbox(value) {
			const idx = this.employeeSelected.findIndex(item => item.id === value.id);
			if (idx !== -1) {
				this.employeeSelected.splice(idx, 1);
			} else {
				this.employeeSelected.push(value);
			}
		}
	},
	async mounted() {
		this.isPreloader = true;
		const { employees, employeeSelected } = await this.getScheduleEmployee(this.editData);
		this.defaultDispatcherList = [ ...employeeSelected, ...employees ];
		this.employeeSelected = employeeSelected;
		this.employeeList = getClonedObject(this.defaultDispatcherList);
		this.isPreloader = false;
	},
};
</script>

<style scoped lang="scss">
@import "employeeWorkSchedulePopup";
</style>
